import { FieldArrayRenderProps } from '../../../lib/formik/Formik';
import { InvestmentFundType } from "../../../redux-store/types/api-types";
import { useHistory } from "react-router";
import { Box, Grid, Typography, useTheme } from "@mui/material";
import { MpowerValidationType } from "../types";
import { CustomeBlueDropDown, PickUpInput } from "./FromInput";
import {
    BankDetails, GetOrderEntryBanksListResponseBody
} from "../../../redux-store/types/orderManagement";

interface LumpsumProps {
    isLoading: boolean;
    id: string | number
    // validation: ValidationInvestment
    data: InvestmentFundType,
    isSubmitting: boolean;
    bankAccountList?: GetOrderEntryBanksListResponseBody;
}


const Lumpsum = (props: LumpsumProps) => {
    const history = useHistory();
    const { palette } = useTheme();
    const { isLoading, id, data, isSubmitting, bankAccountList } = props;
    const { validataion: validation, folios, validations, purchaseAllowed, lumpsum } = data

    const { pathname } = history.location

    const isInvestMore = pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'

    const getValidation = validations?.filter((item: MpowerValidationType) => item?.transactionType === "SUB")[0] ?? {}

    const validationsAvailable = Object.keys(getValidation).length > 0

    const isNewFolioSelected = `${lumpsum?.lumpsumFolio ?? ""}`?.toLowerCase() === "new folio"

    let minLumpsumAmount = getValidation?.minimumInstallmentAmount ?? 0

    if (isInvestMore || (!isInvestMore && !isNewFolioSelected)) {
        minLumpsumAmount = getValidation?.addtionalMinimumPurchaseAmpunt ?? 0;
    }

    return (
        (!validationsAvailable && !isLoading) ? (
            <Typography
                variant="h6"
                color={palette.error[500]}
                sx={{ textAlign: 'center', m: 4 }}
            >
                {`No lumpsum transaction allowed as validations aren't available`}
            </Typography>
        ) : (
            purchaseAllowed === 'N' ? (
                <Box m={'auto auto'}>
                    <Typography
                        variant="h6"
                        color={palette.error[500]}
                        sx={{ textAlign: 'center', m: 4 }}
                    >
                        Lumpsum purchase is not allowed.
                    </Typography>
                </Box>
            ) : (
                <Grid container spacing={2}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <PickUpInput
                            label='Lumpsum Amount'
                            inputType={'number'}
                            name={`fund[${id}].lumpsum.lumpAmount`}
                            isLoading={isLoading}
                            disabled={isSubmitting}
                            // value={fund[id]?.lumpsum?.lumpAmount}
                            minValue={minLumpsumAmount}
                        />
                    </Grid>
                    {!isInvestMore && (
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomeBlueDropDown
                                isLoading={isLoading}
                                label='Select Folio'
                                disabled={isSubmitting}
                                name={`fund[${id}].lumpsum.lumpsumFolio`}
                                list={folios?.availableFolios?.map((item: string) => ({ label: item, value: item }))}
                            />
                        </Grid>
                    )}
                </Grid>
            )
        )
    );
};

export default Lumpsum